import { ChangeEventHandler } from 'react';
import { ValidationError } from './ValidationError';
import { Box, TextField } from '@mui/material';

type ChannelNameInputProps = {
  name: string;
  error: string | null;
  onChange: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
};

export const ChannelNameInputField = ({ name = '', error, placeholder = 'channel-name', onChange }: ChannelNameInputProps) => {

  return (
    <Box sx={{ p: 2}}>
      <TextField
        id="channel-display-name"
        fullWidth
        label="Channel Name"
        onChange={onChange}
        variant="outlined"
        value={name}
        helperText={error && error}
        error={!!error}
      />
    </Box>
  );
};